var exports = {
  "i": "xaee3c4fa--022e1d--wrapper",
};

module.exports = exports;
